import {
  SET_USER_INFO
} from "./authActions";

const initialState = {
  user: {
    name: '',
    email: '',
    phone: '',
    role: ''
  }
};

const authReducer = (state = initialState, action ) => {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        user: action.payload
      };

    default:
      return { ...state };
  }
};

export default authReducer;
